export default __webpack_public_path__ + "static/media/card_premium_2.c016160d.svg";